import { useMutation } from "@apollo/client/react";
import { CheckOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useLocation, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { PublishIngredientDocument } from "../../../gql/generated/graphqlSchema.tsx";
import { LoadingBlocker } from "../../../components/LoadingBlocker.tsx";
import { routes } from "../../../routes.ts";
import { useIngredient } from "../IngredientContext.tsx";

export const SaveIngredientButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { ingredient } = useIngredient();
  const [saveIngredient, { loading }] = useMutation(PublishIngredientDocument, {
    onCompleted: () => void navigate({ pathname: routes.ingredientDetail.to(ingredient.id), hash: location.hash }),
  });

  return (
    <>
      <LoadingBlocker loading={loading} />
      <Button
        icon={<CheckOutlined />}
        loading={loading}
        onClick={() => void saveIngredient({ variables: { id: ingredient.id } })}
        type="primary"
      >
        {t("ingredients.save")}
      </Button>
    </>
  );
};
